module.exports = __webpack_public_path__ + "static/media/bng.b170a2e4.png";